import { adminUtilsAPI } from '@/providers/apis/admin-utils/admin-utils';
import { sessionService } from '@/providers/services/auth/session';
import router from '@/routers/router';
import { sortByProperty } from '@/utils/utils';
import { Vue, Component } from 'vue-property-decorator';
import AddKeys from './add-keys/add-keys';
import KeysList from './keys-list/keys-list';

@Component({
    name: 'tenant-keys',
    components: {
        'add-keys': AddKeys,
        'keys-list': KeysList,
    },
})

export default class TenantKeys extends Vue {

    private activeComponent: any = 'keys-list';

    private keysData: any = {};

    private isEditMode: boolean = false;
    // ----------------------------------------------------------------------------
    // Actions
    private created() {
        if (!sessionService.isSuperAdminUser()) {
            const menu = sessionService.headerMenuOnPermission() || [];
            if (menu && menu.length > 0) {
                const path: any = menu[0].path;
                this.$router.push(path);
            } else {
                this.$router.push('/login');
            }
        }
    }

    private updated() {
        if (!sessionService.isSuperAdminUser()) {
            const menu = sessionService.headerMenuOnPermission() || [];
            if (menu && menu.length > 0) {
                const path: any = menu[0].path;
                this.$router.push(path);
            } else {
                this.$router.push('/login');
            }
        }
    }

    private onSwitchComponent(key: string, keysData: any, isEditMode: boolean) {
        this.keysData = keysData;
        this.isEditMode = isEditMode;
        this.activeComponent = key;
    }
}
